import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Reportes/rcompra';
import RCompraVenta from './RCompraVenta';

const mstp = state => {
    return {...state.rcompra}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(RCompraVenta)
